import { useRouter } from "router2";

import { isWebPath, toWebPath } from "~/hook/base/useIsWeb.ts";

export const useAppRouter = () => {
  const router = useRouter();

  const push: typeof router.push = (history) => {
    let target = history;
    if (isWebPath() && !history.pathname.startsWith("/web")) {
      target = {
        ...history,
        pathname: toWebPath(history.pathname),
      };
    }
    router.push(target);
  };

  const replace: typeof router.replace = (history) => {
    let target = history;
    if (isWebPath() && !history.pathname.startsWith("/web")) {
      target = {
        ...history,
        pathname: toWebPath(history.pathname),
      };
    }
    router.replace(target);
  };

  return {
    ...router,
    push,
    replace,
  };
};
